import { render, staticRenderFns } from "./ConfigurationEditModal.vue?vue&type=template&id=28c4be6c"
import script from "./ConfigurationEditModal.vue?vue&type=script&lang=js"
export * from "./ConfigurationEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports